// Overlay stacking constants — single source of truth for bottom-positioned
// floating elements (chat FAB, TOC button, nudge bubble).
//
// Mobile stacking order (bottom-up):
//   Chat FAB     → BASE_BOTTOM
//   Nudge bubble → NUDGE_BOTTOM
// (The mobile TOC drawer also sat at BASE_BOTTOM until it was removed
// 2026-08-02 at a measured 0.09% open rate.)

// Base dimensions
export const FAB_SIZE = 56       // w-14 h-14 = 3.5rem
export const OVERLAY_GAP = 8    // spacing between stacked elements
export const BASE_BOTTOM = 24   // default bottom for FABs
export const NUDGE_BOTTOM = 32  // nudge bubble default (slightly above FAB)

// Delay before non-critical overlay elements (chat FAB) appear after page
// mount. Lets the homepage cascade (~530ms) settle before introducing
// secondary UI.
export const OVERLAY_ENTRANCE_DELAY = 1000

// Custom event names used for overlay coordination
export const OVERLAY_EVENTS = {
  MOBILE_NAV_OPENED: 'wgis:mobile-nav-opened',
  MOBILE_NAV_CLOSED: 'wgis:mobile-nav-closed',
  BOTTOM_DOCK_CHANGED: 'bottom-dock-changed',
  COOKIE_BANNER_HIDDEN: 'cookie-banner-hidden',
  CONSENT_RESET: 'consent-reset',
} as const

// CSS bottom value that adds env(safe-area-inset-bottom) to a px base.
// Use as the inline `bottom` style on fixed overlays so they clear the iOS
// home indicator. Requires viewport-fit=cover (set in app/layout.tsx).
export function safeBottom(basePx: number): string {
  return `calc(${basePx}px + env(safe-area-inset-bottom))`
}
